<app-navsec></app-navsec>
<div class="container mt-5">
    <div class="col-lg-12">
        <div class="text-center">
            <h3>Categorías de Nuestros Productos</h3>
            <hr>
        </div>
        <div class="row row-cols-1 row-cols-md-4 mt-5">
            <div class="col mb-4" *ngFor="let item of cat">
                <div class="card h-100">
                    <img [src]="item.imagen" class="card-img-top" alt="...">
                    <div class="card-body text-center">
                        <h5 class="card-title">{{item.portada}}</h5>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-light btnPer" style="width: 100%;" (click)="openProducts(item.nombre)">VER PRODUCTOS</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>